module.exports = __webpack_public_path__ + "gallery.4088791f4a0c2b84f30bb08cec9bf783.svg";